import React, { useState, cloneElement } from "react";
import styles from "./Auth.module.css";
import InputField from "./InputField";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from 'react-bootstrap/Button';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { signUp } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import aws_exports from "../../aws-exports";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

Amplify.configure(aws_exports);

function Register() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        company: "",
        jobTitle: "",
        email: "",
        password: "",
        reenterPassword: "",
        phoneNumber: "",
    });
    const [eye, setEye] = useState(false); // For handling password visibility

    const navigate = useNavigate();

    function handleInputChange(field, value) {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };
    
    function eyeClick() {
        setEye((prev) => !prev)
    }

    async function handleSubmit(e) {
        console.log("Registration submit request received!");

        e.preventDefault();

        const { firstName, lastName, company, jobTitle, email, password, reenterPassword, phoneNumber } = formData;

        if (!firstName || !lastName || !company || !jobTitle || !email || !password || !phoneNumber) {
            toast.error("Please fill out all fields.");
            console.log("Please fill out all fields.");
            return;
        } else if(!isPossiblePhoneNumber(formData.phoneNumber, "US")) {
            toast.error("Please, enter a 10 digit phone number.");
            console.log("Please, enter a 10 digit phone number.");
            return;
        } else if(!email.toLowerCase().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                toast.error("Please, enter an appropriate email format: email@address.com.");
                console.log("Please, enter an appropriate email format: email@address.com.");
                return;
        }

        if (password !== reenterPassword) {
            toast.error("Passwords do not match.");
            console.log("Passwords do not match.");
            return;
        }

        try {
            console.log("Trying registration...");

            // Signing up a user using AWS Amplify
            const signUpResponse = await signUp({
                username: email,
                password,
                attributes: {
                    email,
                    phone_number: phoneNumber,
                    given_name: firstName,
                    family_name: lastName,
                    "custom:company": company,
                    "custom:job_title": jobTitle,
                },
            });

            console.log("Sign up response: ", signUpResponse);

            navigate("/auth/login?source=registered");
        } catch (error) {
            console.error("Sign up error: ", error);
            toast.error(error.message || "An error occurred during registration.");
        }
    }

    return (
        <div className={styles["registeration-content"]}>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeButton={true}
            />

            <div className={styles["auth-form-header"]}>
                <h5>Create an Account</h5>

                <p className={styles["switch-auth"]}>
                    Already have an account? <a href="/auth/login" className={styles["txt-link"]}>Login</a> 
                </p>
            </div>

            <form className={styles["register-form"]} onSubmit={handleSubmit}>
                <div className={styles["form-name-row"]}>
                    <InputField 
                        desc="First name*"
                        type="text"
                        name="firstName"
                        placeholder="Enter your first name"
                        value={formData.firstName}
                        onChange={(value) => handleInputChange("firstName", value)}
                    />

                    <InputField 
                        desc="Last name*"
                        type="text"
                        name="lastName"
                        placeholder="Enter your last name"
                        value={formData.lastName}
                        onChange={(value) => handleInputChange("lastName", value)}
                    />
                </div>

                <InputField 
                    desc="Company*"
                    type="text"
                    name="company"
                    placeholder="Enter your company name"
                    value={formData.company}
                    onChange={(value) => handleInputChange("company", value)}
                />

                <InputField 
                    desc="Job title*"
                    type="text"
                    name="jobTitle"
                    placeholder="Enter your job title"
                    value={formData.jobTitle}
                    onChange={(value) => handleInputChange("jobTitle", value)}
                />

                <InputField 
                    desc="Email address*"
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={(value) => handleInputChange("email", value)}
                />

                <div className={`${styles["input"]} ${styles["phone-input"]}`}>
                    <p className={styles["input-desc"]}>Phone number*</p>

                    <PhoneInput
                        placeholder="Enter your phone number"
                        countryCallingCodeEditable={false}
                        defaultCountry="US"
                        value={formData.phoneNumber}
                        onChange={(value) => handleInputChange("phoneNumber", value)}
                        className={styles["input-field"]}
                    />
                </div>

                <div className={`${styles["input"]} ${styles["password-input"]}`}>
                    <p className={styles["input-desc"]}>Password*</p>

                    <div className={styles["pwd"]}>
                        <input 
                            type={eye? "text" : "password"}
                            className={styles["input-field"]}
                            name="password"
                            placeholder="Enter your password"
                            value={formData.password}
                            onChange={(e) => handleInputChange("password", e.target.value)}
                            // required
                        />

                        {eye?
                            <VisibilityIcon 
                                className={styles["viz-icon"]} 
                                onClick={eyeClick}
                            />
                            :
                            <VisibilityOffIcon 
                                className={styles["viz-icon"]} 
                                onClick={eyeClick}
                            />
                        }
                    </div>
                </div>

                <div className={`${styles["input"]} ${styles["password-input"]}`}>
                    <p className={styles["input-desc"]}>Reenter password*</p>

                    <div className={styles["pwd"]}>
                        <input 
                            type={eye? "text" : "password"}
                            className={styles["input-field"]}
                            name="reenterPassword"
                            placeholder="Reenter your password"
                            value={formData.reenterPassword}
                            onChange={(e) => handleInputChange("reenterPassword", e.target.value)}
                            // required
                        />

                        {eye?
                            <VisibilityIcon 
                                className={styles["viz-icon"]} 
                                onClick={eyeClick}
                            />
                            :
                            <VisibilityOffIcon 
                                className={styles["viz-icon"]} 
                                onClick={eyeClick}
                            />
                        }
                    </div>
                </div>

                <div className={styles["auth-form-footer"]}>
                    <p className={styles["auth-form-footer-txt"]}>
                        By submitting this form, you agree to the <a href="/tos" className={styles["txt-link"]}>terms of service</a> 
                    </p>

                    <Button 
                        className={`${styles["btn-dark"]}`} 
                        type="submit"
                    >
                        Submit
                        <ArrowForwardIcon className={styles["btn-arrow"]}/>
                    </Button>
                </div>         
            </form>
        </div>
    )
}

export default Register;